/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-underscore-dangle */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useCallback, useEffect } from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { Formik, Form } from 'formik';
import { withFormikDevtools } from 'formik-devtools-extension';
import FormikInput from 'src/components/formik/FormikInput';
import { isProduction } from 'src/config/index';
import PropTypes from 'prop-types';
import { usePrevious } from 'src/utils/ReactHooksUtil';
import './LoginForm.scss';
import { useHistory } from 'react-router';
import { REQUEST_STATUS } from 'src/constants/CommonConstants';
import { AuthYupSchema, AuthDefaultProps } from '../AuthPropTypes';
import { confirmCredentialsAction } from '../actions/AuthActions';

const Render = (props) => {
    // DEV TOOL
    if (!isProduction()) {
        withFormikDevtools(props);
    }

    const {
    // errors,
    // touched,
        isSubmitting,
    } = props;

    return (
        <Form autoComplete="disabled">
            <div className="form-group">
                <label>User Name</label>
                <FormikInput
                    name="identifier"
                    type="text"
                    className="form-control"
                    placeholder="User Name"
                />
            </div>
            <div className="form-group">
                <label>Password</label>
                <FormikInput
                    name="password"
                    type="password"
                    className="form-control"
                    placeholder="Password"
                />
            </div>
            <button
                type="submit"
                disabled={isSubmitting}
                className="btn btn-black"
            >
                Login
            </button>
        </Form>
    );
};

Render.propTypes = {
    isSubmitting: PropTypes.bool.isRequired,
};

// setting submit button state after submitting
let setSubmitting = () => {};

const LoginForm = () => {
    const history = useHistory();
    // REDUX
    const dispatch = useDispatch();
    const { isLoggedIn, loginConfirmationStatus } = useSelector(
        (state) => state.AuthReducer,
        shallowEqual,
    );

    // if current record changed or request status changed the enable submit
    usePrevious(
        {
            loginConfirmationStatus,
        },
        (prev) => {
            if (
                prev.loginConfirmationStatus !== loginConfirmationStatus
        && loginConfirmationStatus !== REQUEST_STATUS.PENDING
            ) {
                setSubmitting(false);
            }
        },
    );

    useEffect(() => {
        if (isLoggedIn) {
            history.push('/');
        }
    }, [
        isLoggedIn,
        history,
    ]);

    const onSubmit = useCallback(
        (values, formikUtils) => {
            ({ setSubmitting } = formikUtils);
            dispatch(
                confirmCredentialsAction({
                    identifier: values.identifier,
                    password: values.password,
                }),
            );
        },
        [
            dispatch,
        ],
    );

    return (
        <div>
            <div className="sidenav">
                <div className="login-main-text">
                    <h2>
                        <img
                            src="/logo.jpg"
                            alt="user"
                            style={{
                                height: '80px',
                            }}
                        />
                        <br />
                        {' '}
                        Welcome Page
                    </h2>
                    <p>Login from here to access.</p>
                </div>
            </div>
            <div className="main">
                <div className="col-md-6 col-sm-12">
                    <div className="login-form">
                        <Formik
                            onSubmit={onSubmit}
                            enableReinitialize
                            initialValues={AuthDefaultProps}
                            validationSchema={AuthYupSchema}
                        >
                            {(formikProps) => <Render {...formikProps} />}
                        </Formik>
                    </div>
                </div>
            </div>
        </div>
    );
};

LoginForm.propTypes = {};

export default LoginForm;
